const formatAccountNumber = (number: any) => {
  //get last 4 digits of account number
  if (number === null || number === undefined) return "";
  if (number.toString().length > 4) {
    return "*******" + number.toString().slice(-4);
  } else {
    return "*******" + number;
  }
};

export default formatAccountNumber;
